import React, { memo, useEffect, useMemo, useState } from "react";
import { Col, Row, Card, Button, Flex, Progress, Tag, Select, Space } from "antd";
import { getImageURL } from "../util/images";
import { useDispatch, useSelector } from "react-redux";
import CourseService from "../util/course";
import useAuth from "../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import Search from "antd/es/input/Search";
import { doArraysOverlap } from "../util/array";
import { fetchProductsAsync } from "../features/shop/shopSlice";

const CourseItem = memo(({ item }) => {
    const navigate = useNavigate();
    const onCourseClick = () => {
        navigate(`/shop/courses/${item.id}`);
    };

    const handleBuy = (e) => {
        // e.preventDefault();
        // e.stopPropagation();
        // if (item.attributes.paymentLink)
        //     window.open(`${item.attributes.paymentLink}?prefilled_email=${user.email}&prefilled_driverId=${user.username}`, "_blank");
    };

    return (
        <Col key={item.id} md={8}>
            <Card
                bordered={false}
                className="CardItem"
                cover={<img alt="" src={getImageURL(item.attributes?.Cover?.data?.attributes.url)} />}
                onClick={onCourseClick}
            >
                <h3>{item.attributes.Title}</h3>
                <p>{item.attributes.Summary}</p>
                <div className="CardTags">
                    {item.attributes.categories.data?.map((category) => (
                        <Tag key={category.attributes.id}>{category.attributes.name}</Tag>
                    ))}
                </div>
                <Flex justify="space-between" gap={25}>
                    {item.attributes.started && (
                        <div className={`CardProgress ${CourseService.calculateProgress(item) === "100" ? "completed" : "null"}`}>
                            <Progress percent={CourseService.calculateProgress(item)} />
                        </div>
                    )}
                    <Button onClick={handleBuy}>{item.attributes.alreadyEnrolled ? "View Course" : "Buy Course"}</Button>
                </Flex>
            </Card>
        </Col>
    );
});

export default function ProductItems() {
    const [courses, setCourses] = useState([]);
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [searchKey, setSearchkey] = useState("");
    const [statusFilter, setStatusFilter] = useState("all");
    const { auth } = useAuth();
    const dispatch = useDispatch();

    // const data = useSelector((state) => state.courses.courses);
    const data = useSelector((state) => state.products.products);
    const status = useSelector((state) => state.products.status);
    const error = useSelector((state) => state.products.error);

    useEffect(() => {
        if (status === "idle" || (status === "fulfilled" && data === null)) {
            dispatch(fetchProductsAsync());
        }
    }, [auth, data, dispatch, status]);

    useEffect(() => {
        const getCategories = (item) => {
            return item.categories.data?.map((category) => category.attributes.name).join(", ");
        };

        const getCourses = () => {
            if (searchKey === "" && selectedCategories?.length === 0 && statusFilter === "all") return data;

            return data.filter((item) => {
                const itemStatus = CourseService.calculateProgress(item);
                const itemCategory = getCategories(item.attributes).toLowerCase();
                return (
                    (searchKey?.length > 0 &&
                        (item.attributes.Title.toLowerCase().includes(searchKey.toLowerCase()) ||
                            itemCategory.includes(searchKey.toLowerCase()))) ||
                    doArraysOverlap(selectedCategories, itemCategory.split(", ")) ||
                    (statusFilter === "new" && itemStatus == 0) ||
                    (statusFilter === "in-progress" && itemStatus > 0 && itemStatus < 100) ||
                    (statusFilter === "completed" && itemStatus == 100)
                );
            });
        };

        setCourses(getCourses());
        // setCourses([])
    }, [statusFilter, searchKey, selectedCategories, data]);

    const getAllCategories = useMemo(() => {
        if (!data) return [];
        const categories = data
            ?.map((item) => item.attributes.categories.data)
            .flat()
            ?.map((category) => category.attributes.name);

        return [...new Set(categories)];
    }, [data]);

    if (status === "pending" || data === null) return <div className="AlertInfo Loading">Loading...</div>;
    if (error) return <p>Error :(</p>;

    if (data?.length === 0) return <div className="AlertInfo">No courses found</div>;

    return (
        <div>
            <div className="SearchWrap">
                <Search
                    size="large"
                    placeholder="Search courses"
                    allowClear
                    onChange={(event) => setSearchkey(event.target.value)}
                    enterButton
                    value={searchKey}
                />
                <Select value={statusFilter} onChange={setStatusFilter}>
                    <Select.Option value="all">Show All</Select.Option>
                    <Select.Option value="new">New</Select.Option>
                    <Select.Option value="in-progress">In Progress</Select.Option>
                    <Select.Option value="completed">Completed</Select.Option>
                </Select>
            </div>
            <Flex wrap="wrap" style={{ marginTop: "30px" }} className="FilterTags">
                {getAllCategories?.map((category) => (
                    <Tag
                        color="default"
                        key={category}
                        className={selectedCategories.includes(category.toLowerCase()) ? "Active" : null}
                        onClick={() => {
                            if (selectedCategories.includes(category.toLowerCase())) {
                                setSelectedCategories(selectedCategories.filter((item) => item !== category.toLowerCase()));
                            } else {
                                setSelectedCategories([...selectedCategories, category.toLowerCase()]);
                            }
                        }}
                    >
                        {category}
                    </Tag>
                ))}
            </Flex>
            <Row gutter={[20, 20]} style={{ marginTop: "30px" }}>
                {courses?.map((item) => (
                    <CourseItem key={item.id} item={item} />
                ))}
                {courses?.length === 0 && <div className="AlertInfo">No courses found</div>}
            </Row>
        </div>
    );
}
